import React,  { useState, useEffect } from 'react'

import {
    Form,
    Button,
    Row,
    Col
} from 'react-bootstrap'

import { useDispatch, useSelector } from 'react-redux'

import Message from '../Message/Message'

import Loader from '../Loader/Loader'

import FormContainer from '../FormContainer/FormContainer'

import { register } from '../../actions/userActions'

import Meta from '../Helmet/Meta'
import './dashboard.css'

const AddUser = ({ location, history }) => {

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const [message, setMessage] = useState(null)

    const dispatch = useDispatch()

    const userRegister = useSelector(state => state.userRegister)


    const { loading, userInfo, error } = userRegister

  //  const redirect = location.search ? location.search.split('=')[1] : '/'


    useEffect(() => {
        if (userInfo) {
            history.push("/userlist")
        }
    }, [userInfo, history])


    const submitHandler = (e) => {
        e.preventDefault()
        if (password !== confirmPassword) {
            setMessage('Passwords do not match')
        } else {
            dispatch(register(name, email, password))
        }
    }

    return (
<div  className="main"  fluid >
        <FormContainer  >
            <Meta
                title=" | Register"
            />
             <br />
            <br /> <br />
            <br />
            <h5> Ceci est un espace pour les administrateurs du site  </h5>
           
        

            <h1 style={{ marginTop: '120px' }}> Ajouter un administrateur </h1>
            {message && <Message variant='danger'>{message}</Message>}
            {error && <Message variant='danger'>{error}</Message>}
            {loading && <Loader />}
            <Form onSubmit={submitHandler}>
            <Row>
                    <Col md={5}>
                        <Form.Group controlId='name'>
                            <Form.Label> Nom et prénom <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Form.Control
                                type="name"
                                placeholder=" "
                                value={name}
                                required
                                onChange={(e) => setName(e.target.value)}
                            ></Form.Control>
                        </Form.Group>
                        <Form.Group controlId='email'>
                            <Form.Label> Email  <span style={{ color: 'red' }}>*</span> </Form.Label>
                            <Form.Control
                                type="email"
                                placeholder=" "
                                value={email}
                                required
                                onChange={(e) => setEmail(e.target.value)}
                            ></Form.Control>
                        </Form.Group>

                    </Col>
                    <Col md={5}>
                        <Form.Group controlId='password'>
                            <Form.Label>  Mot de passe   <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Form.Control
                                type="password"
                                placeholder=""
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            ></Form.Control>
                        </Form.Group>
                        <Form.Group controlId='confirmPassword'>
                            <Form.Label>  Confirmez le mot de passe  <span style={{ color: 'red' }}>*</span>  </Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="  "
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            ></Form.Control>
                        </Form.Group>
                  
                        <Button type="submit"  style={{  backgroundColor: 'red'  }} >add</Button>
                    </Col>
                </Row>
                <br />
                <br />  <br />
            </Form>
            
        </FormContainer>
        </div>
    )
}

export default AddUser
